/**
 * 应用主题 Vuex 模块
 * 管理：暗黑模式、主题色、灰色模式、界面显示
 */
import { nextTick } from 'vue'
import { setCssVar, genPrimaryColors, injectThemeStyle, lsGet, lsSet, mix } from '../../utils/theme'

export default {
  namespaced: true,

  state: {
    isDark: lsGet('app_isDark', false),
    primaryColor: lsGet('app_primaryColor', '#4f7afd'),
    greyMode: lsGet('app_greyMode', false),
    colorWeak: lsGet('app_colorWeak', false),
    showTagsView: lsGet('app_showTagsView', true),
    showLogo: lsGet('app_showLogo', true),
    showFooter: lsGet('app_showFooter', true),
  },

  mutations: {
    SET_DARK(state, val) {
      state.isDark = val
      lsSet('app_isDark', val)
      if (val) {
        document.documentElement.classList.add('dark')
      } else {
        document.documentElement.classList.remove('dark')
      }
    },
    SET_PRIMARY(state, color) {
      state.primaryColor = color
      lsSet('app_primaryColor', color)
      genPrimaryColors(color)
      injectThemeStyle(color)
    },
    SET_GREY(state, val) {
      state.greyMode = val
      lsSet('app_greyMode', val)
      if (val) {
        document.getElementById('app').classList.add('grey-mode')
      } else {
        document.getElementById('app').classList.remove('grey-mode')
      }
    },
    SET_WEAK(state, val) {
      state.colorWeak = val
      lsSet('app_colorWeak', val)
      if (val) {
        document.getElementById('app').classList.add('color-weak')
      } else {
        document.getElementById('app').classList.remove('color-weak')
      }
    },
    SET_TAGS(state, val) { state.showTagsView = val; lsSet('app_showTagsView', val) },
    SET_LOGO(state, val) { state.showLogo = val; lsSet('app_showLogo', val) },
    SET_FOOTER(state, val) { state.showFooter = val; lsSet('app_showFooter', val) },
  },

  actions: {
    // 初始化主题
    init({ commit, state }) {
      // 暗色模式：默认白色（亮色模式），用户可手动切换
      commit('SET_DARK', state.isDark)
      // 初始化主题色（延迟到 nextTick，确保 EP 组件 DOM 已就绪）
      nextTick(() => {
        genPrimaryColors(state.primaryColor)
        injectThemeStyle(state.primaryColor)
      })
      // 恢复灰色/色弱模式
      if (state.greyMode) document.getElementById('app').classList.add('grey-mode')
      if (state.colorWeak) document.getElementById('app').classList.add('color-weak')
    },

    // 切换暗色
    toggleDark({ commit, state }) {
      commit('SET_DARK', !state.isDark)
    },

    // 设置主题色
    setColor({ commit }, color) {
      commit('SET_PRIMARY', color)
    },
  }
}
